<template>
  <div
    :class="[
      'dialog-footer flex-row justify-end gap-3',
      { 'dialog-footer--no-border': hideBorder },
    ]"
  >
    <slot />
  </div>
</template>

<script lang="ts" setup>
withDefaults(defineProps<{ hideBorder?: boolean }>(), { hideBorder: false })
</script>

<style lang="scss" scoped>
.dialog-footer {
  padding: 24px;
  border-top: 0.5px solid var(--divider);

  &--no-border {
    border-top: none;
  }
}
</style>
